// Tiny shared form primitives used across the EditClaimPanel sub-components.

export const Section = ({ children }) => (
  <div className="border border-gray-300 rounded bg-gray-50 px-3 py-2.5">{children}</div>
);

export const FieldLabel = ({ children, required }) => (
  <label className="text-gray-500 text-xs mb-0.5 block">
    {children}{required && <span className="text-red-500 ml-0.5">*</span>}
  </label>
);
